import React, {Fragment, useContext, useState} from 'react';
import {
    Button,
    Typography,
} from '@material-ui/core';
import {Formik, Form} from 'formik';

import CoberturasForm from './Forms/CoberturasForm';
import PolizaForm from './Forms/PolizaForm';
import ClienteForm from './Forms/ClienteForm';

import validationSchema from './FormModel/validationSchema';
import formModel from './FormModel/formModel';
import formInitialValues from './FormModel/formInitialValues';

import useStyles from './styles';
import axios from 'axios';

import EmisionSuccess from "./EmisionSuccess";
import Loading from "../../../../Loading";
import ProgressBar from "../../../../customer/ProductsCustomer/ProgressBar";
import house_white_icon from "../../../../../assets/images/white_house_icon.png";
import DetailsForm from "./Forms/DetailsForm.jsx";
import IndicatorsContext from "../../../../../context/AdviserContext/IndicatorsContext";
import AuthContext from "../../../../../context/AuthContext";

const {formId, formField} = formModel;

function _renderStepContent(step, cuotaMensual, errors, additionalStep) {
    if (additionalStep) {
        switch (step) {
            case 0:
                return <DetailsForm formField={formField} errors={errors}/>;
            case 1:
                return <PolizaForm formField={formField}/>;
            case 2:
                return <ClienteForm formField={formField} errors={errors}/>;
            case 3:
                return <CoberturasForm formField={formField} cuotaMensual={cuotaMensual}/>;
            default:
                return <div>Not Found</div>;
        }
    } else {
        switch (step) {
            case 0:
                return <PolizaForm formField={formField}/>;
            case 1:
                return <ClienteForm formField={formField} errors={errors}/>;
            case 2:
                return <CoberturasForm formField={formField} cuotaMensual={cuotaMensual}/>;
            default:
                return <div>Not Found</div>;
        }
    }
}

export default function CheckoutPage(props) {
    const classes = useStyles();
    const {continueCotizacion, emisionValues, idCotizacion, additionalStep} = props;
    const steps = additionalStep ? ['Detalle', 'Información', 'Cliente', 'Coberturas'] : ['Información', 'Cliente', 'Coberturas'];
    const [activeStep, setActiveStep] = useState(0);
    const currentValidationSchema = validationSchema[additionalStep ? activeStep : activeStep + 1];
    const isLastStep = activeStep === steps.length - 1;
    const [emisionResponse, setEmisionResponse] = useState(null);
    const [finalValues, setFinalValues] = useState(null);
    const {handleModified} = useContext(IndicatorsContext)
    const {authToken} = useContext(AuthContext)

    async function _submitForm(values, actions) {
        let url = process.env.REACT_APP_BACK_SERVER + '/emitir/combinado';

        values.origen = 'affinity'
        values.premium = emisionValues.premium;

        values.clientes.map(cliente => {
            if (cliente.personaJuridica === '1')
                cliente.dni = cliente.cuit
            cliente.dni = cliente.dni.toString()
        })

        let equipoElectronicoValues = []

        values.detalleBicicletas.map(item => {
            if (item.sumaAseguradaBicicletas !== '')
                equipoElectronicoValues.push({
                    descripcion: item.descripcionBicicletas,
                    sumaAsegurada: parseInt(item.sumaAseguradaBicicletas),
                    codigo: item.codigoBicicletas,
                    codigoGrupo: item.codigoGrupoBicicletas
                })
        })

        values.detalleMonopatines.map(item => {
            if (item.sumaAseguradaMonopatines !== '')
                equipoElectronicoValues.push({
                    descripcion: item.descripcionMonopatines,
                    sumaAsegurada: parseInt(item.sumaAseguradaMonopatines),
                    codigo: item.codigoMonopatines,
                    codigoGrupo: item.codigoGrupoMonopatines
                })
        })

        values.detalleEquipoElectronico.map(item => {
            if (item.sumaAseguradaElectronico !== '')
                equipoElectronicoValues.push({
                    descripcion: item.descripcionElectronico,
                    sumaAsegurada: parseInt(item.sumaAseguradaElectronico),
                    codigo: item.codigoElectronico,
                    codigoGrupo: item.codigoGrupoElectronico
                })
        })

        if (equipoElectronicoValues.length !== 0)
            values.equipoElectronico = equipoElectronicoValues

        setFinalValues(values);

        axios.post(url, {...values, ...{idCotizacion: idCotizacion}},{
            headers:{
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            }}).then(res => {
                // console.log(res.data)
                setEmisionResponse(res.data)
                handleModified()
        }).catch( err => {
            console.log(err);
            alert('No se pudo completar la operación, vuelva a cargar la página')
        });

        actions.setSubmitting(false);
        setActiveStep(activeStep + 1);
    }

    function _handleSubmit(values, actions) {
        if (isLastStep) {
            _submitForm(values, actions);
        } else {
            setActiveStep(activeStep + 1);
            actions.setTouched({});
            actions.setSubmitting(false);
        }
    }

    function _handleBack() {
        setActiveStep(activeStep - 1);
    }

    return (
        <React.Fragment>
            <div className={classes.iconCircle}>
                <img src={house_white_icon} style={{width: "32px", height: "auto"}}/>
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    fontSize: "18px",
                    justifyContent: "center",
                    marginTop: "20px",
                    marginBottom: "30px",
                }}
            >
                Complete los siguientes pasos:
            </div>
            <div style={{marginBottom: "20px"}}>
                    <ProgressBar activeStep={activeStep} stepTitles={steps}/>
            </div>
            <Fragment>
                {activeStep === steps.length ? (
                    <Fragment>
                        {(emisionResponse !== null && finalValues !== null)
                            ? <EmisionSuccess finalValues={finalValues} emisionResponse={emisionResponse}
                                              idCotizacion={idCotizacion} setActiveStep={setActiveStep}
                                                setEmisionResponse={setEmisionResponse}/>
                            : (
                                <Fragment>
                                    <Typography variant="h5" gutterBottom>
                                        Procesando el pedido. Por favor espere...
                                    </Typography>
                                    <Loading/>
                                    <Typography variant="body1" gutterBottom align="center">
                                        Esto puede demorar hasta 60 segundos.
                                    </Typography>
                                </Fragment>
                            )
                        }
                    </Fragment>
                ) : (
                    <Formik
                        initialValues={continueCotizacion ? emisionValues : formInitialValues}
                        validationSchema={currentValidationSchema}
                        validateOnBlur={false}
                        onSubmit={_handleSubmit}
                    >
                        {({isSubmitting, errors}) => (
                            <Form id={formId}>
                                {_renderStepContent(activeStep, emisionValues.premium, errors, additionalStep)}
                                <div className={classes.buttons}>
                                    {activeStep !== 0 && (
                                        <Button onClick={_handleBack} className={classes.buttonBack} variant="contained">
                                            Atras
                                        </Button>
                                    )}
                                    <div className={classes.buttons}>
                                        <Button
                                            disabled={isSubmitting}
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            className={classes.buttonContained}
                                        >
                                            {isLastStep ? 'Emitir' : 'Siguiente'}
                                        </Button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                )}
            </Fragment>
        </React.Fragment>
    );
}
